import {
  AssignModel,
  createClient,
  IdPathParameters,
  OwnerResponse,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

const client = createClient('/rest/locations');

export const ocpiLocationAccessManagementPermissions = {
  ASSIGN: 'cpms.assign-location',
  UNASSIGN: 'cpms.unassign-location',
  SEARCH_OWNERS: 'cpms.search-location-owners'
};

export type AssignPoolRequest = AssignModel;
export type UnassignPoolRequest = AssignModel;

export const assignOcpiLocation: SaveOperation<AssignPoolRequest, void, string> = postRequestFactory<
  AssignPoolRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: ocpiLocationAccessManagementPermissions.ASSIGN
});

export const unassignOcpiLocation: SaveOperation<UnassignPoolRequest, void, string> = postRequestFactory<
  UnassignPoolRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: ocpiLocationAccessManagementPermissions.UNASSIGN
});

export const getOcpiLocationOwners: SearchOperation<OwnerResponse, IdPathParameters<string>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<string>
>(client, {
  pattern: '/{id}/owners',
  permissionId: ocpiLocationAccessManagementPermissions.SEARCH_OWNERS
});
